



















import { Project, getAssignedProjects } from "@/api/project-api";
import { Component, Vue } from "vue-property-decorator";
import { statusSearchDashboard } from "@/status";
import { getStatusCode } from "@/status";
import { getTaskStatusCode } from "@/models/task-status";

export interface SearchDashboardProjectQuery {
  keyword: string;
  status: string;
  projectCount?: number;
}

@Component({})
export default class SearchDashboardProjectBar extends Vue {
  query: SearchDashboardProjectQuery = {
    keyword: "",
    status: String(getStatusCode("施工中"))
  };

  get statusOptions() {
    if (this.$store.state.user.hasRole) {
      return [
        {
          text: "全て",
          value: ""
        },
        ...statusSearchDashboard
      ];
    }

    return [
      {
        text: "全て",
        value: ""
      },
      {
        text: "未着工",
        value: getTaskStatusCode("未着工")
      },
      {
        text: "施工前",
        value: getTaskStatusCode("施工前")
      },
      {
        text: "施工中",
        value: getTaskStatusCode("施工中")
      }
    ];
  }

  public created() {
    // このやり方イマイチかも。
    // 親でもquery持って親でgetした方がいい？
    this.search();
  }

  async search() {
    let projects: Project[] = [];
    if (!this.query.status) {
      projects = await getAssignedProjects(
        this.query.keyword,
        this.query.status,
        projects.length
      );
    } else {
      projects = await getAssignedProjects(
        this.query.keyword,
        this.query.status
      );
    }
    this.$emit("search", projects, this.query.status, this.query.keyword);
  }
}
